import React from "react";
var initialNotificationContext = {
  addNotification: () => undefined,
  removeNotification: () => {}
};
export var useNotificationContext = ref => {
  var addNotification = notification => {
    var _ref$current;

    return ref === null || ref === void 0
      ? void 0
      : (_ref$current = ref.current) === null || _ref$current === void 0
      ? void 0
      : _ref$current.addNotification(notification);
  };

  var removeNotification = notificationId => {
    var _ref$current2;

    return ref === null || ref === void 0
      ? void 0
      : (_ref$current2 = ref.current) === null || _ref$current2 === void 0
      ? void 0
      : _ref$current2.removeNotification(notificationId);
  };

  return {
    addNotification,
    removeNotification
  };
};
export var getNotificationContext = () =>
  /*#__PURE__*/ React.createContext(initialNotificationContext);
